import React from 'react';
import { Clickable, LoadingBalls, Overlay } from '@moda/om';

import './PaymentSourceButton.scss';

export type PaymentSourceButtonProps = {
  label: string;
  image: string;
  size?: 'small' | 'large';
  loading?: boolean;
  onClick?: () => void;
};

export const PaymentSourceButton: React.FC<PaymentSourceButtonProps> = ({
  label,
  size = 'large',
  image,
  loading,
  onClick
}) => (
  <Clickable
    className={`PaymentSourceButton PaymentSourceButton--${size}`}
    aria-label={label}
    onClick={onClick}
    data-testid="paymentSourceButton"
  >
    <img className="PaymentSourceButton__image" alt={label} src={image} width={150} height={36} />

    <Overlay show={loading}>
      <LoadingBalls />
    </Overlay>
  </Clickable>
);
